// Une relance d'achat entre deux sections : une phrase, le bouton, la
// garantie. Placée là où la conviction culmine (après « pourquoi ça
// revient », après le schéma), pour que personne n'ait à remonter chercher
// le bouton.
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'
import { Check } from './Icons'

export default function Relay ({ line }) {
  const r = useT().relay
  return (
    <div className="lp-relay lp-rv">
      <div className="lp-wrap lp-relay__in">
        <p className="lp-relay__t">{line}</p>
        <div className="lp-relay__act">
          <Link to="/register" className="lp-btn lp-btn--main">{r.cta} <span aria-hidden="true">→</span></Link>
          <span className="lp-relay__n"><Check />{r.note}</span>
        </div>
      </div>
    </div>
  )
}
